import { Component, JSX } from "react";
import { appContext } from "../../../AppContext";
import Header, { IProps as IHeaderProps } from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import "./Styles.scss";
import { ProgressIndicatorIndeterminate } from "@serendie/ui";
import { AlertDialog, IAlertDialogOptions } from "@iconics/components";

export class Layout extends Component<IProps, IState>
{
    private get appContext() { return appContext(); }
    private get alert() { return appContext().alert; }
    private get appState() { return appContext().state; }

    constructor(props: IProps)
    {
        super(props);

        this.state =
        {
            isPrivate: props.isPrivate,
            isLoading: false,
            showAlert: false,
            alertTitle: '',
            alertMessage: '',
        };

    }

    public componentDidMount(): void
    {
        this.appState.autoMap(this, i => ({
            isLoading: i.isLoading,
        }));

        // todo: bug:
        // pages fire their componentDidMount before the layout so if a page tries to show an alert in componentDidMount it doesn't work
        // solution is to get rid of the changed event and have the alert get it's state from the appState
        this.alert.changed = (show, title, message, options) => this.alertChanged(show, title, message, options);
    }

    public componentWillUnmount(): void
    {
        this.alert.changed = undefined;
    }

    private alertChanged(show: boolean, title: string, message: string, options?: IAlertDialogOptions): Promise<void>
    {
        return new Promise((resolve, reject) =>
        {
            this.setState({
                showAlert: show,
                alertTitle: title,
                alertMessage: message,
                alertOptions: options,
            }, () => resolve());
        });
    }

    private hideAlert(): void
    {
        this.alert.hide();
    }

    public render(): JSX.Element
    {
        return (
            <>
                {
                    this.state.isPrivate &&
                    <div className="page-container layout">
                        <Sidebar {...this.props} />
                        <main>
                            <div className="rightPanel">
                                <header style={{ paddingBottom: '16px' }}>
                                    <Header {...this.props as unknown as IHeaderProps} />
                                </header>
                                {this.props.children}
                                <div className={`layout__progress-indicator ${this.state.isLoading ? 'layout__progress-indicator--show' : 'layout__progress-indicator--hide'}`}>
                                    <div className='layout__progress-indicator-backdrop' />
                                    <ProgressIndicatorIndeterminate
                                        className='layout__progress-indicator-spinner'
                                        type='circular'
                                        size='large'
                                        color='subtle'
                                    />
                                </div>
                            </div>
                        </main>
                    </div>
                }
                {!this.state.isPrivate && this.props.children}
                <AlertDialog
                    show={this.state.showAlert}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    options={this.state.alertOptions}
                    onClose={() => this.hideAlert()}
                />
            </>);
    }
}

export default Layout;

interface IProps
{
    isPrivate: boolean;
    children?: React.ReactNode;
}

interface IState
{
    isPrivate: boolean;
    isLoading: boolean;
    showAlert: boolean;
    alertTitle: string;
    alertMessage: string;
    alertOptions?: IAlertDialogOptions;
}
